<template>
  <v-dialog v-model="showDialog" no-click-animation persistent width="300">
    <v-card color="primary" class="pt-3">
      <v-card-text class="text-center white--text">
        {{ dialogMessage }}
        <v-progress-linear indeterminate color="white" class="mt-3 mb-1">
        </v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "cvi-loading-dialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    dialogMessage: {
      type: String,
      default: "Salvando Alterações..."
    }
  }
};
</script>
